import { Button } from '@casavo/base-ui'
import React, { MutableRefObject, useState } from 'react'

import { ContactAgencyForm } from '@/components/ContactAgencyForm'
import { ContextValue } from '@/context/Cities'
import { ModalContextType } from '@/context/ModalContext'
import Close from '@/design-lib/components/Icons/Close'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { ListingCate } from '@/page-commons/listingBySlug'

import { modalDetailFormInner } from './styles.css'

type Props = {
  cities: ContextValue
  closeModal: ModalContextType['closeModal']
  property: ListingCate
  similarPropertiesLength: number
  similarPropertiesRef: MutableRefObject<HTMLDivElement>
}

export const ModalDetailForm: React.FC<Props> = ({
  cities,
  closeModal,
  property,
  similarPropertiesLength,
  similarPropertiesRef,
}) => {
  const [formIsInSuccess, setFormIsInSuccess] = useState(false)

  const getWrapperClassName = (): string => {
    if (formIsInSuccess) return modalDetailFormInner.success
    return navigator.userAgent.match(/android/i) ? modalDetailFormInner.android : modalDetailFormInner.default
  }

  return (
    <>
      <Button
        ariaLabel="Close"
        className={sprinkles({ position: 'absolute', right: 'm', top: 'm' })}
        Icon={(props) => <Close {...props} />}
        shapeVariant="round"
        styleVariant="tertiary"
        onClick={() => closeModal()}
      />
      <div className={getWrapperClassName()}>
        <ContactAgencyForm
          cities={cities}
          property={property}
          similarPropertiesLength={similarPropertiesLength}
          similarPropertiesRef={similarPropertiesRef}
          onClose={closeModal}
          onSuccess={setFormIsInSuccess}
        />
      </div>
    </>
  )
}
